/**
 * @NOTE-DP: this is a hackish internal prototype
 * Don't expect any kind of code quality from it
 * and by not means DO NOT copy anything from here
 */

import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  calculateFees,
  DonationProvider,
  PaymentMethodType,
  FeeCoveredBy,
} from '@joindeed/calculate-fees';
import { MenuItem } from '@material-ui/core';
import { useSelector } from 'react-redux';

import FormCheckbox from 'retired/FormCheckbox';
import FormTextFieldRedesign from 'retired/FormTextFieldRedesign';
import FormSelectRedesign from 'retired/FormSelectRedesign';
import { selectUser } from 'entities/user/selectors';
import history from 'utils/history';

const FeesPlaygroundPage = (): JSX.Element => {
  const user = useSelector(selectUser);
  const isAdmin = user?.type === 'Admin';

  if (!isAdmin) {
    history.replace('/');
  }

  const [amount, setAmount] = useState(10);
  const [donationProvider, setDonationProvider] = useState(DonationProvider.PayPal);
  const [donationPaymentMethod, setDonationPaymentMethod] = useState(PaymentMethodType.Card);
  const [feeCoveredBy, setFeeCoveredBy] = useState(FeeCoveredBy.User);
  const [coverFeesParam, setCoverFeesParam] = useState(false);
  const [isRecurring, setIsRecurring] = useState(false);
  const [isSandbox, setIsSandbox] = useState(false);
  const [paypalDeedFeesMode, setPaypalDeedFeesMode] = useState<'default' | 'new' | 'old'>(
    'default'
  );
  const [nonprofitCountryCode, setNonprofitCountryCode] = useState<string | undefined>();
  const [cardCountryCode, setCardCountryCode] = useState<string | undefined>();

  const isCorporate =
    donationPaymentMethod === PaymentMethodType.DeedCredit ||
    donationPaymentMethod === PaymentMethodType.Payroll ||
    donationPaymentMethod === PaymentMethodType.CorporateDonation ||
    donationPaymentMethod === PaymentMethodType.Matching ||
    donationPaymentMethod === PaymentMethodType.ExternalMatching;

  const paypalDeedFeesConfig = {
    default: undefined,
    new: { corporate: 2.5, employee: 2.5 },
    old: { corporate: 2.25, employee: 2.8 },
  };
  const applicationFees = paypalDeedFeesConfig[paypalDeedFeesMode];

  let result;
  let error;
  try {
    result = calculateFees({
      amount,
      coverFeesParam,
      donationProvider,
      nonprofitCountryCode,
      cardCountryCode,
      donationPaymentMethod,
      isRecurring,
      feeCoveredBy,
      isSandbox,
      // eslint-disable-next-line no-nested-ternary
      applicationFeeSetting: applicationFees
        ? isCorporate
          ? applicationFees.corporate
          : applicationFees.employee
        : undefined,
    });
  } catch (e) {
    error = e.message;
  }

  return (
    <>
      <Helmet title="Fees Playground" />
      <h1>Fees Playground</h1>

      <div style={{ marginBottom: 20 }}>
        <FormTextFieldRedesign
          inputProps={{ value: amount, type: 'number' }}
          label="Amount"
          onChange={(e): void => {
            setAmount(Number(e.target.value));
          }}
          variant="outlined"
        />
      </div>

      <div style={{ marginBottom: 20 }}>
        <FormCheckbox
          input={{
            onChange: () => setCoverFeesParam(!coverFeesParam),
            value: coverFeesParam,
          }}
          label="Cover fees (what user chooses in the app)"
        />
        <FormCheckbox
          input={{
            onChange: () => setIsRecurring(!isRecurring),
            value: isRecurring,
          }}
          label="Recurring"
        />
        <FormCheckbox
          input={{
            onChange: () => setIsSandbox(!isSandbox),
            value: isSandbox,
          }}
          label="Sandbox"
        />
      </div>

      <div style={{ marginBottom: 20 }}>
        Donation provider:
        <br />
        <FormSelectRedesign
          value={donationProvider}
          onChange={(e): void => {
            setDonationProvider(e.target.value as DonationProvider);
          }}
        >
          {Object.values(DonationProvider).map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </FormSelectRedesign>
      </div>
      <div style={{ marginBottom: 20 }}>
        Payment method type:
        <br />
        <FormSelectRedesign
          value={donationPaymentMethod}
          onChange={(e): void => {
            setDonationPaymentMethod(e.target.value as PaymentMethodType);
          }}
        >
          {Object.values(PaymentMethodType).map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </FormSelectRedesign>
      </div>
      <div style={{ marginBottom: 20 }}>
        Fee covered by:
        <br />
        <FormSelectRedesign
          value={feeCoveredBy}
          onChange={(e): void => {
            setFeeCoveredBy(e.target.value as FeeCoveredBy);
          }}
        >
          {Object.values(FeeCoveredBy).map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </FormSelectRedesign>
      </div>
      <div style={{ marginBottom: 20 }}>
        Application fee company setting
        <br />
        <FormSelectRedesign
          value={paypalDeedFeesMode}
          onChange={(e): void => {
            setPaypalDeedFeesMode(e.target.value);
          }}
        >
          <MenuItem value="default">Default</MenuItem>
          <MenuItem value="new">2.5%/2.5%</MenuItem>
          <MenuItem value="old">2.8%/2.25%</MenuItem>
        </FormSelectRedesign>
      </div>

      <div style={{ marginBottom: 20 }}>
        <FormTextFieldRedesign
          inputProps={{ value: nonprofitCountryCode }}
          label="Nonprofit country code"
          onChange={(e): void => {
            setNonprofitCountryCode(e.target.value);
          }}
          variant="outlined"
        />{' '}
        <FormTextFieldRedesign
          inputProps={{ value: cardCountryCode }}
          label="Card country code"
          onChange={(e): void => {
            setCardCountryCode(e.target.value);
          }}
          variant="outlined"
        />
      </div>

      {error && <div style={{ color: 'red' }}>Error when calculating fees: {error}</div>}

      {result && (
        <div style={{ marginTop: 40 }}>
          <h3>Calculated fees</h3>
          Provider fee amount: ${result.providerFeeAmount}
          <br />
          Deed fee amount: ${result.applicationFeeAmount}
          <br />
          {result.ppgfFeeAmount && (
            <span>
              PPGF fee amount: ${result.ppgfFeeAmount}
              <br />
            </span>
          )}
          Total fee amount: ${result.totalFeeAmount}
        </div>
      )}
    </>
  );
};

export default FeesPlaygroundPage;
